export const GreetingFilter = () => {
    return () => {
        const hour = new Date().getHours();
        if (hour < 12) {
            return 'modules.login.greetingMorning';
        }
        else if (hour >= 12 && hour < 18) {
            return 'modules.login.greetingAfternoon';
        }
        else if (hour >= 18) {
            return 'modules.login.greetingEvening';
        }
        else {
            return 'modules.login.greetingDefault';
        }
    };
};
